import React from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import { MAP_SETTINGS_IMAGES } from '../../../assets'

import CloseIcon from '../../common/icons/CloseIcon'

const MapSettingsMenu = ({ uiStore, dataStore, t }) => {
  const onCloseClick = () => {
    uiStore.hideMapSettingsMenu()
    uiStore.hideLayerSettings()
  }

  const BASE_MAPS = [
    { id: 'openStreet', label: t('MAP_TYPES.OPEN_STREET') || 'Open Street', img: MAP_SETTINGS_IMAGES.OPEN_STREET_LAYER },
    { id: 'googleRoadmap', label: t('MAP_TYPES.GOOGLE_ROAD') || 'Google Roadmap', img: MAP_SETTINGS_IMAGES.GOOGLE_ROADMAP_LAYER },
    { id: 'googleSatellite', label: t('MAP_TYPES.GOOGLE_SAT') || 'Google Satellite', img: MAP_SETTINGS_IMAGES.GOOGLE_SATELLITE_LAYER },
    { id: 'googleHybrid', label: t('MAP_TYPES.GOOGLE_HYB') || 'Google Hybrid', img: MAP_SETTINGS_IMAGES.GOOGLE_HYBRID_LAYER },
    { id: 'googleTerrain', label: t('MAP_TYPES.GOOGLE_TER') || 'Google Terrain', img: MAP_SETTINGS_IMAGES.GOOGLE_TERRAIN_LAYER }
  ]

  return (
    <div
      className='map-settings-sleek'
      style={{
        position: 'absolute',
        bottom: 'calc(100% + 12px)',
        left: '0',
        padding: '8px 12px',
        width: 'max-content',
        boxSizing: 'border-box',
        backgroundColor: '#ffffff',
        borderRadius: '10px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        fontFamily: '"Inter", "Google Sans", Roboto, sans-serif',
        animation: 'fadeIn 0.2s ease-out',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch'
      }}
    >
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 10
      }}
      >
        <div>
          <h2 style={{ fontSize: '13px', fontWeight: '600', color: '#1a1a1a', whiteSpace: 'nowrap' }}>
            {t('MAP_SETTINGS.BASE_MAP') || 'Map Layers'}
          </h2>
        </div>
        <div>
          <button
            onClick={onCloseClick}
            type='button'
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '4px',
              margin: '0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#666',
              lineHeight: 0
            }}
          >
            <CloseIcon />
          </button>
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'flex-start' }}>
        {BASE_MAPS.map(layer => {
          const isSelected = uiStore.baseMap === layer.id

          return (
            <div
              key={layer.id}
              onClick={() => {
                uiStore.baseMap = layer.id
              }}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                cursor: 'pointer',
                borderRadius: '6px',
                padding: '4px',
                width: '64px',
                boxSizing: 'border-box',
                transition: 'transform 0.15s ease',
                transform: isSelected ? 'scale(1.03)' : 'scale(1)'
              }}
              onMouseEnter={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.transform = 'scale(1.02)'
                }
              }}
              onMouseLeave={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.transform = 'scale(1)'
                }
              }}
            >
              <div style={{
                width: '56px',
                height: '56px',
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: isSelected ? '0 0 0 2px #0052cc, 0 4px 8px rgba(0,82,204,0.2)' : '0 2px 4px rgba(0,0,0,0.1)',
                position: 'relative',
                flexShrink: 0,
                transition: 'box-shadow 0.2s ease'
              }}
              >
                <img
                  src={layer.img}
                  alt={layer.label}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    display: 'block',
                    imageRendering: '-webkit-optimize-contrast',
                    WebkitBackfaceVisibility: 'hidden',
                    backfaceVisibility: 'hidden'
                  }}
                />
              </div>
              <span style={{
                fontSize: '10px',
                textAlign: 'center',
                marginTop: '6px',
                color: isSelected ? '#0052cc' : '#4a4a4a',
                fontWeight: isSelected ? '600' : '400',
                lineHeight: '1.2',
                width: '100%',
                wordBreak: 'break-word'
              }}
              >
                {layer.label}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default withTranslation()(inject('uiStore', 'dataStore')(observer(MapSettingsMenu)))
